import { beginLoading, endLoading } from "./loadingSpinner";
import { ROLE_STORE, TYPE_KEY } from "../common/constant";
import rest from "../common/rest";
import ObjectUtils from "../utils/ObjectUtils";

export const REDUCER = "ROLES/";

export const ROLE_LIST_LOAD_REQUEST = REDUCER + "ROLE_LIST_LOAD_REQUEST";
export const ROLE_LIST_LOAD_SUCCESS = REDUCER + "ROLE_LIST_LOAD_SUCCESS";
export const ROLE_LIST_LOAD_FAIL = REDUCER + "ROLE_LIST_LOAD_FAIL";

export const PERMISSION_LIST_LOAD_REQUEST = REDUCER + "PERMISSION_LIST_LOAD_REQUEST";
export const PERMISSION_LIST_LOAD_SUCCESS = REDUCER + "PERMISSION_LIST_LOAD_SUCCESS";
export const PERMISSION_LIST_LOAD_FAIL = REDUCER + "PERMISSION_LIST_LOAD_FAIL";

export const EDIT_ROLE = REDUCER + "EDIT_ROLE";

export const ASSIGN_PERMISSION = REDUCER + "ASSIGN_PERMISSION";

// state props
export const ROLE_LIST = "roleList";
export const PERMISSION_LIST = "permissionList";
export const EDITED_ROLE = "editedRole";

const { deepClone } = ObjectUtils;

const initialState = {
  [ROLE_LIST]: [],
  [PERMISSION_LIST]: [],
  [EDITED_ROLE]: undefined
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case ROLE_LIST_LOAD_SUCCESS:
      newState = {
        ...state,
        [ROLE_LIST]: action[ROLE_LIST]
      };
      break;
    case ROLE_LIST_LOAD_FAIL:
      newState = {
        ...state,
        [ROLE_LIST]: []
      };
      break;
    case PERMISSION_LIST_LOAD_SUCCESS:
      newState = {
        ...state,
        [PERMISSION_LIST]: action[PERMISSION_LIST]
      };
      break;
    case PERMISSION_LIST_LOAD_FAIL:
      newState = {
        ...state,
        [PERMISSION_LIST]: []
      };
      break;
    case EDIT_ROLE:
      newState = {
        ...state,
        [EDITED_ROLE]: action[EDITED_ROLE]
      };
      break;
    default:
      newState = { ...state };
      break;
  }

  return newState;
}

export function loadRoles() {
  return (dispatch) => {
    dispatch({ [TYPE_KEY]: ROLE_LIST_LOAD_REQUEST });

    dispatch(beginLoading());

    rest.doGet(`/authentication/roles?simple=true`).then((roleList) => {
      dispatch({ [TYPE_KEY]: ROLE_LIST_LOAD_SUCCESS, [ROLE_LIST]: roleList });

      dispatch(endLoading());
    });
  };
}

export function loadPermissions() {
  return (dispatch) => {
    dispatch({ [TYPE_KEY]: PERMISSION_LIST_LOAD_REQUEST });

    dispatch(beginLoading());

    rest.doGet(`/authentication/permissions`).then((permissionList) => {
      dispatch({ [TYPE_KEY]: PERMISSION_LIST_LOAD_SUCCESS, [PERMISSION_LIST]: permissionList });

      dispatch(endLoading());
    });
  };
}

export function editRole(role) {
  return (dispatch) => {
    dispatch({ [TYPE_KEY]: EDIT_ROLE, [EDITED_ROLE]: role });
  };
}

export function saveRole() {
  return (dispatch, getState) => {
    const role = getState()[ROLE_STORE][EDITED_ROLE];

    if (role.id) {
      rest.doPut(`/authentication/roles/${role.id}`, JSON.stringify(role)).then((createdRole) => {
        dispatch(loadRoles());
        dispatch(editRole(undefined));
      });
    } else {
      rest.doPost(`/authentication/roles`, JSON.stringify(role)).then((updatedRole) => {
        dispatch(loadRoles());
        dispatch(editRole(undefined));
      });
    }
  };
}

export function deleteRole(roleId) {
  return (dispatch) => {
    rest.doDelete(`/authentication/roles/${roleId}`).then((createdRole) => {
      dispatch(loadRoles());
    });
  };
}

export function propertyChange(propName, value) {
  return (dispatch, getState) => {
    const role = getState()[ROLE_STORE][EDITED_ROLE];
    role[propName] = value;

    dispatch({ [TYPE_KEY]: EDIT_ROLE, [EDITED_ROLE]: deepClone(role) });
  };
}
